import { useTranslation } from 'react-i18next'
import { SearchNoBg } from '../icons'

type Props = {
  searchText: string
  onChangeInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  iconClass?: string
  inputClass?: string
  showSearchIcon?: boolean
  placeholder?: string
  disabled?: boolean
}

export const Search = ({
  searchText,
  onChangeInput,
  className,
  iconClass,
  inputClass,
  showSearchIcon = true,
  placeholder,
  disabled,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={`flex bg-white items-center rounded-full ${className}`}>
      {showSearchIcon && <SearchNoBg className={`text-navy-900 text-opacity-50 ${iconClass}`} />}
      <input
        value={searchText}
        onChange={(e) => onChangeInput(e)}
        placeholder={placeholder ? placeholder : t('common.search')}
        className={`focus:outline-none w-full text-sm text-navy-900 placeholder:text-opacity-50 ${inputClass}`}
        disabled={disabled}
      />
    </div>
  )
}
